import script from "./ModelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelModal.vue?vue&type=script&setup=true&lang=js"

import "./ModelModal.vue?vue&type=style&index=0&id=6e299ad2&lang=css"
import "./ModelModal.vue?vue&type=style&index=1&id=6e299ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e299ad2"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QCarousel,QCarouselSlide,QImg,QSpace,QToolbar,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QBtnToggle,QOptionGroup,QSeparator,QTabPanels,QTabPanel,QCardActions,QSpinnerHourglass,QDialog,QCard,QCardSection,QTable});qInstall(script, 'directives', {ClosePopup});
